import React, { useEffect, useState } from 'react';
import Slider from '@polestar/component-warehouse-react/components/slider/Slider';
import styled from '@emotion/styled';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import { createTransition, MotionEasings, } from '@polestar/component-warehouse-react/tokens/motion/Motion';
const Seekbar = ({ isDragging, updateSeekbar, canPlay, displayedTime, playing, duration, videoPlayerRef, ...props }) => {
    var _a;
    const [hasTransition, setHasTransition] = useState(false);
    useEffect(() => {
        const shouldHaveTransition = playing && !isDragging && !updateSeekbar && canPlay && displayedTime !== 0;
        if (shouldHaveTransition && !hasTransition) {
            setHasTransition(true);
        }
        else if (!shouldHaveTransition && hasTransition) {
            setHasTransition(false);
        }
    }, [canPlay, displayedTime, isDragging, playing, hasTransition, updateSeekbar]);
    const transition = hasTransition
        ? {
            animate: true,
            animateTransition: createTransition({
                duration: duration - displayedTime,
                ease: MotionEasings.linear,
            }),
            value: duration,
        }
        : {
            value: ((_a = videoPlayerRef === null || videoPlayerRef === void 0 ? void 0 : videoPlayerRef.current) === null || _a === void 0 ? void 0 : _a.currentTime) || 0,
            animate: false,
        };
    return React.createElement(StyledSlider, { ...props, ...transition });
};
const StyledSlider = styled(Slider) `
  height: ${Spacings.xLarge};
`;
export default Seekbar;
